import React, { useEffect } from "react";
import { LoadContacts } from "modules/app/components/LoadContacts";
import { ContactList, Chat } from "../../components";
import { Container } from "./styles";
import _ from "lodash";
import { useParams } from "react-router-dom";
import { useMainState } from "modules/app/contexts";
import { ContactsContext } from "../../contexts";

const Contacts = function () {
  const { contacts } = useMainState();
  const { id } = useParams();

  return (
    <Container>
      <LoadContacts>
        <ContactList contacts={_.uniqBy(contacts, "id")} />

        {id && (
          <ContactsContext contactId={id} contacts={contacts}>
            <Chat />
          </ContactsContext>
        )}
      </LoadContacts>
    </Container>
  );
};

export default Contacts;
